export default __webpack_public_path__ + "static/media/view-dashboard-outline.acdec816.svg";